const enviroment = process.env.REACT_APP_ENVIROMENT;

export const baseUrl = process.env[`REACT_APP_BASE_URL_${enviroment}`];

export const soleTraderColorsEnum = Object.freeze({
    "ACTIVE": "#EB742E",
    "INACTIVE": "#47455F",
    "MISSINGDOCS": "#E4E000",
    "PENDING_RIGHT_TO_WORK": "#B1DD8B",
})

export const soleTraderStatusEnum = Object.freeze({
    "ACTIVE": "ACTIVE",
    "INACTIVE": "INACTIVE",
    "ARCHIVED": "ARCHIVED",
    "MISSINGDOCS": "MISSINGDOCS",
    "PENDING_RIGHT_TO_WORK": "PENDING_RIGHT_TO_WORK",
})